import { render, staticRenderFns } from "./SpacerSpecial.vue?vue&type=template&id=797f3360&scoped=true&lang=html&"
import script from "./SpacerSpecial.vue?vue&type=script&lang=js&"
export * from "./SpacerSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f3360",
  null
  
)

export default component.exports